// removed by extract-text-webpack-plugin
module.exports = {"container":"_63abe1824c_src-common-_createCursorLock_container","enabled":"fdde03cacb_src-common-_createCursorLock_enabled"};


//////////////////
// WEBPACK FOOTER
// ./src/common/createCursorLock.css
// module id = 889
// module chunks = 0